<template>
  <div class="page flex-col">
    <div class="group_2 flex-col">
      <van-divider
        :style="{ color: '#fa8a19', borderColor: '#fa8a19', padding: '0 16px' }">领取登记</van-divider
      >
          <van-form>
            <br/>
            <van-cell-group inset>
              <van-notice-bar
                scrollable
                left-icon="volume-o"
                text="请输入您在我院的体检预留信息！(如果信息错误，关联不上会领取失败)"
              />
              <van-field
                v-model="registerData.realName"
                required
                label="真实姓名"
                :rules="[{ required: true, message: '请填写姓名' }]"
              />
              <van-field
                v-model="registerData.phone"
                required
                label="手机号码"
                :rules="[
                  { required: true },
                  {
                    pattern: /^1[3456789]\d{9}$/,
                    message: '手机号码格式错误！',
                  },
                ]"/>
              <van-field
                  v-model="registerData.smsBindingCode"
                  required
                  clearable
                  label="短信验证码"
                  placeholder="输入验证码"
                  >
                  <template #button>
                        <van-button size="small" type="primary"  @click.prevent="sendSmsCode" :disabled="isSmsSend">{{ sendBtnText }}</van-button>
                  </template>
              </van-field>
            </van-cell-group>
            <van-divider
            :style="{
              color: '#fa8a19',
              borderColor: '#fa8a19',
              padding: '0 16px',
            }">相关协议签署</van-divider>
          <van-checkbox v-model="registerData.informed">同意并签署如下协议：</van-checkbox>
          <p class="textIndentation">
            <router-link to="/userServiceAgreement">《用户服务协议》</router-link>
            <router-link to="/privacyAgreement">、《隐私服务协议》</router-link>
          </p>
          </van-form>
          
          <div style="margin: 16px">
            <van-button
              round
              block
              color="linear-gradient(to right, #f67f34, #d55809)"
              native-type="submit"
              @click="getData">确认</van-button>
          </div>
          <span class="text_3"></span>
      <div class="image-text_1 flex-col">
        <span class="text-group_1"></span>
      </div>
      <div class="group_3 flex-col">
        <div class="text-group_2 flex-col">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ref, toRefs, reactive, onMounted } from "vue";
import { postHospAndMobile,postSmsByMobile } from "../../api/register";
import { postUserLog } from "../../api/userlog";
import { showConfirmDialog } from "vant";
import { useRouter } from "vue-router";
import { showDialog } from "vant";
export default {
  setup() {
    const showBinging = ref(false);
    const activeAll = ref(1);
    const active = ref(0);
    const router = useRouter();
    const timer = ref(0)
    const counter = ref(60)
    const sendBtnText=ref('发送验证码');
    const isSmsSend= ref(false);
    const ulog = reactive({
      UserLog: {
        path: "",
      },
    });
    const kpianawait = reactive({
      cellGroupBackground: "#F1F1F1",
    });
    const state = reactive({
      registerData: {
        hospitalName: "",
        hospitalCode: "",
        realName: "",
        nowHospName: "",
        nowHospCode: "",
        phone: "",
        idCard: "",
        smsBindingCode: "",
        informed: "",
        isDoctor: "",
        pageTabId: "1",
      },
    });
    const hosp = reactive({
      HospInfo: {
        hospId: "",
      },
    });
    const getData = () => {
      console.log(state.registerData.realName);
      if (state.registerData.realName == ""|| state.registerData.phone =="" || state.registerData.smsBindingCode =="" ) {
        showDialog({
            title: "错误提醒",
            message: "请填写必要的绑定信息!",
            theme: "round-button",
          }).then(() => {
            
          });
      } else if(!state.registerData.informed){
        showDialog({
            title: "错误提醒",
            message: "您需要先签署相关协议!",
            theme: "round-button",
          }).then(() => {
            
          });
      }else{
        console.log(state.registerData);
        postHospAndMobile(state.registerData).then((res) => {
          console.log(res);
          if (res.data.code == 20000) {
              showConfirmDialog({
                        title: "领取成功",
                        message: "您已经完成领取的全部事项！我们会根据您的本年度体检情况评估分析，请留意微信服务消息。\n",
                  })
                  .then(() => {
                    router.push('personAction');
                  })
                  .catch(() => {});
           
          } else {
            showDialog({
              title: "错误提醒",
              message: res.data.message,
              theme: "round-button",
            }).then(() => {
            
            });
          }
        });
      }
    };
     /**
       * 重置倒计时
       */
       const reset =()=> {
        isSmsSend.value = false;
        sendBtnText.value = '发送验证码';
        if (timer.value) {
          clearInterval(timer.value)
          counter.value = 60
          timer.value = null
        }
      };
    /**
       * 倒计时
       */
    const countDown =()=> {
        timer.value= setInterval(() => {
          sendBtnText.value = `${counter.value}秒`
          counter.value--
          if (counter.value < 0) {
            reset()
          }
        }, 1000)
      };
      /**
       * 发送验证码
       */
    const sendSmsCode =() =>{
        // 判断手机号是否符合要求
        console.log(state.registerData.phone);
        if (state.registerData.phone.length !== 11) {
          showDialog({
              title: "错误提醒",
              message: '请输入11位手机号',
              theme: "round-button",
            }).then(() => {
            });
          return false
        }
        // 调用接口，发送短信验证码
        postSmsByMobile(state.registerData).then((res) => {
          console.log(res);
          if (res.data.code == 20000) {
            isSmsSend.value=true;
            // 开始倒计时，60s之后才能再次点击
             countDown();
          } else {
            showDialog({
              title: "错误提醒",
              message: "网路异常，稍后再试",
              theme: "round-button",
            }).then(() => {
            
            });
          }
        });
     
      };
    onMounted(() => {
      console.log("页面打开");
      ulog.UserLog.path = router.currentRoute.value.fullPath;
      console.log("当前页面路径==" + ulog.UserLog.path);
      postUserLog(ulog.UserLog).then(() => {});
    });
    return {
      hosp,
      kpianawait,
      ...toRefs(state),
      getData,
      showBinging,
      activeAll,
      active,
      countDown,
      sendBtnText,
      reset,
      timer,
      sendSmsCode,
      isSmsSend
   
    };
  },
};
</script>
<style scoped lang="css" src="./assets/index.css" />
